import { Image } from '@chakra-ui/react'
import LogoDark from 'shared/images/logo-dark.svg'
import LogoLight from 'shared/images/logo-light.svg'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const Logo = ({ ...props }) => {
  const { colorMode } = useColorMode()
  const logoSrc = colorMode === 'light' ? LogoLight : LogoDark
  return <Image src={logoSrc} objectFit="contain" height="full" width="full" {...props} />
}
